import React, { useEffect, useState } from 'react';
import { DigitalMapBusRoute } from 'models/digitalMap';
import { SimulatedBusOverlay } from '../SimulatedBusOverlay/SimulatedBusOverlay';
import { useMapDisplayContext } from '../MapDisplayContext';
import { GPSBusOverlay } from '../GPSBusOverlay/GPSBusOverlay';

interface BusRouteState {
  route: DigitalMapBusRoute;
  polyline: google.maps.Polyline;
}

interface Props {
  routes: DigitalMapBusRoute[];
}

export const BusRoutes: React.FC<Props> = ({ routes }) => {
  const [busRoutes, setBusRoutes] = useState<BusRouteState[]>([]);

  const { filters, googleMap } = useMapDisplayContext();

  const transportCategorySelected = filters.categories.includes('TRANSPORT');

  // Update the bus routes effect to handle selected route
  useEffect(() => {
    // Clear existing routes
    busRoutes.forEach((route) => route.polyline.setMap(null));
    setBusRoutes([]);

    if ((routes?.length ?? 0) === 0) {
      return;
    }

    if (!transportCategorySelected) {
      return;
    }

    if (routes && googleMap) {
      const newRoutes = routes
        .filter((route) => !filters.busRouteId || route.id === filters.busRouteId)
        .map((route) => {
          if (route.route && route.route.length > 0) {
            try {
              const coordinates = route.route.map(
                (coord) => new google.maps.LatLng(coord.lat, coord.lng)
              ) as google.maps.LatLng[];

              const polyline = new google.maps.Polyline({
                path: coordinates,
                map: googleMap,
                strokeColor: route.color || '#44BC7F',
                strokeWeight: 8,
                strokeOpacity: 1,
                zIndex: 1,
              });

              return {
                route,
                polyline,
              };
            } catch (e) {
              console.error('Error drawing bus route polyline:', e);
            }
          }
          return null;
        })
        .filter((route): route is BusRouteState => route !== null);

      setBusRoutes(newRoutes);
    }

    return () => {
      busRoutes.forEach((route) => route.polyline.setMap(null));
    };
  }, [routes, googleMap, filters.busRouteId, transportCategorySelected]);

  return (
    <>
      {busRoutes.map((route, index) =>
        route.route.bus_tracker_type === 'SIMULATED' ? (
          <SimulatedBusOverlay key={`${route.route.id}-${index}`} route={route.route} />
        ) : (
          <GPSBusOverlay key={`${route.route.id}-${index}`} route={route.route} />
        )
      )}
    </>
  );
};
